let swiper;
window.globals = {};
const body = document.getElementsByTagName('body')[0];
const lightboxImages = document.querySelectorAll("[lightbox-toggle] .main-product__media-slide-inner");
const initLightbox = (lightboxImages.length > 0);

const createLightboxSkeleton = () => {
  // Create skeleton for lightbox
  const lightbox = document.createElement('div');
  const lightboxContainer = document.createElement('div');
  const lightboxClose = document.createElement('div');
  const swiperContainer = document.createElement('div');
  const swiperWrapper = document.createElement('div');
  const swiperBtnNext = document.createElement('div');
  const swiperBtnPrev = document.createElement('div');
  const swiperPagination = document.createElement('div');


  // Add classes
  lightbox.classList.add('c-lightbox');
  lightboxContainer.classList.add('c-lightbox__container');
  lightboxClose.classList.add('c-lightbox__close');
  lightboxClose.setAttribute('tabindex', '0');
  lightboxClose.innerHTML = 'X';
  swiperContainer.classList.add('swiper-container');
  swiperWrapper.classList.add('swiper-wrapper');
  swiperBtnNext.classList.add('swiper-button-next');
  swiperBtnPrev.classList.add('swiper-button-prev');
  swiperPagination.classList.add('swiper-pagination');

  // Append created divs
  lightboxContainer.appendChild(lightboxClose);
  swiperContainer.appendChild(swiperWrapper);
  swiperContainer.appendChild(swiperBtnNext);
  swiperContainer.appendChild(swiperBtnPrev);
  swiperContainer.appendChild(swiperPagination);
  lightboxContainer.appendChild(swiperContainer);
  lightbox.appendChild(lightboxContainer);
  body.appendChild(lightbox);

  swiperBtnNext.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\" style=\"&#10;\">\n" +
    "<path d=\"M29 39L36 32L29 25\" stroke=\"#FEFEFE\" stroke-width=\"1.8\"/>\n" +
    "<rect x=\"1\" y=\"63\" width=\"62\" height=\"62\" rx=\"31\" transform=\"rotate(-90 1 63)\" stroke=\"#696969\" stroke-width=\"2\"/>\n" +
    "</svg>";

  swiperBtnPrev.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\">\n" +
    "<path d=\"M35 25L28 32L35 39\" stroke=\"#FEFEFE\" stroke-width=\"1.8\"/>\n" +
    "<rect x=\"63\" y=\"1\" width=\"62\" height=\"62\" rx=\"31\" transform=\"rotate(90 63 1)\" stroke=\"#696969\" stroke-width=\"2\"/>\n" +
    "</svg>";

  lightboxClose.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n" +
    "<path d=\"M4 4L20 20\" stroke=\"#696969\" stroke-width=\"1.8\"/>\n" +
    "<path d=\"M4 20L20 4\" stroke=\"#696969\" stroke-width=\"1.8\"/>\n" +
    "</svg>"

  // Set variables to reference the lightbox
  globals.lightboxRef = document.querySelector('.c-lightbox');
  globals.swiperWrapperRef = document.querySelector(
    '.c-lightbox .swiper-wrapper',
  );
};

if (initLightbox) {
  createLightboxSkeleton();

  lightboxImages.forEach((el, index) => {
    // Add click function to lightbox images
    // el.addEventListener('click', imageClick, false);
    el.querySelector('.main-product__media-zoom').addEventListener("click", imageClick, false);
    function imageClick() {
      // Clear swiper before trying to add to it
      globals.swiperWrapperRef.innerHTML = '';

      // Loop through images with lightbox data attr
      // Create html for lightbox carousel
      lightboxImages.forEach((img) => {
        // Create clone of current image in loop
        const image = img.cloneNode(true);
        // Create divs
        const slide = document.createElement('div');
        const imageContainer = document.createElement('div');
        // Add classes
        slide.classList.add('swiper-slide');
        imageContainer.classList.add('c-lightbox__image');
        // Append images to the slides, then slides to swiper wrapper
        imageContainer.appendChild(image);
        slide.appendChild(imageContainer);
        globals.swiperWrapperRef.appendChild(slide);
      });

      // Init Swiper
      swiper = new Swiper('.c-lightbox .swiper-container', {
        initialSlide: index,
        loop: true,
        slidesPerView: 1,
        speed: 750,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        zoom: true,
        fadeEffect: {
          crossFade: false,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
          sensitivity: 1,
          forceToAxis: true,
          invert: true,
        },
        multipleActiveThumbs: true,
        // thumbs: {
        //   swiper: productSlider,
        // },
      });

      // Add the class to open the lightbox
      // Add overflow hidden to the body to prevent scrolling
      globals.lightboxRef.classList.add('open');
      body.classList.add('overflowHidden');
    }
  });

  document.addEventListener('click', ({ target }) => {
    if (target.matches('.c-lightbox__close')) {
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove('open');
      body.classList.remove('overflowHidden');
    }
  }, false);

  // Close lightbox on escape key press
  document.addEventListener('keydown', ({ key }) => {
    if (key === 'Escape') {
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove('open');
      body.classList.remove('overflowHidden');
    }
  });

  const destroySwiper = (swiper, timeout) => {
    setTimeout(() => {
      swiper.destroy();
    }, timeout);
  };
}

//usage, add lightbox-toggle attribute to swiper elements